export enum HeaderKey {
  Accept = 'accept',
  Authorization = 'authorization',
  ContentType = 'content-type'
}
